import './index.scss';
import { Link, NavLink } from 'react-router-dom';
import LogoVS from '../../assets/images/coollogo_init.png';
import LogoName from '../../assets/images/coollogo_name.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faHome, faSuitcase, faUser} from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';

const Sidebar = () => {
  return (
    <div className='nav-bar'>
      <Link className='logo' to='/'>
        <img src={LogoVS} alt="logo" />
      </Link>
      <nav>
        <NavLink exact="true" activeclassname="active" to="/">
          <FontAwesomeIcon icon={faHome} color="4d4d4e"/>
        </NavLink>
        <NavLink exact="true" activeclassname="active" className="about-link" to="/about">
          <FontAwesomeIcon icon={faUser} color="4d4d4e"/>
        </NavLink>
        <NavLink exact="true" 
          activeclassname="active"
           className="contact-link"
           to="/contact">
          <FontAwesomeIcon icon={faEnvelope} color="4d4d4e" />
        </NavLink>
        <NavLink exact="true" 
          activeclassname="active" 
          className="project-link"
          to="/projects">
          <FontAwesomeIcon icon={faSuitcase} color="4d4d4e" />
        </NavLink>
      </nav>
      <ul>
        <li>
          <a
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/in/valeria-s-45348888/"
          >
          <FontAwesomeIcon icon={faLinkedin} color="white" />
          </a>
        </li>
        <li>
          <a
          target="_blank"
          rel="noreferrer"
          href="https://github.com/ValeSer"
          >
          <FontAwesomeIcon icon={faGithub} color="white" />
          </a>
        </li>
      </ul>
    </div>
  )
}

export default Sidebar;